export default __webpack_public_path__ + "static/media/mouth-watering.99637244.jpg";